import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { ClinicService } from 'src/app/shared/services/clinic.service';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { ClinicInterface } from 'src/app/shared/models/clinic.interface';

export interface ClinicNotificationInput {
  // Pas d'input spécifique nécessaire
}

export interface ClinicNotificationResult {
  clinicId: number; // Ajout d'un champ pour l'ID de la clinique
  message: string;
  targets: string | undefined; // Ajout d'un champ pour les cibles (vétérinaires, cliniques, etc.)
}

@Component({
  selector: 'app-clinic-notification-popup',
  templateUrl: './clinic-notification-popup.component.html',
  styleUrls: ['./clinic-notification-popup.component.scss']
})
export class ClinicNotificationPopupComponent implements OnInit, IDialogContentComponent<ClinicNotificationResult, ClinicNotificationInput> {
  input?: ClinicNotificationInput;
  notificationForm: FormGroup;
  clinics: ClinicInterface[] = [];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly clinicService: ClinicService,
    private readonly tokenStorage: TokenStorageService
  ) {
    this.notificationForm = this.formBuilder.group({
      clinicId: ['', [Validators.required]], // Ajout d'un champ pour l'ID de la clinique
      message: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(255)]],
      targets: [false, []] // Ajout d'un champ pour les cibles (vétérinaires, cliniques, etc.)
    });
  }

  ngOnInit(): void {
    const userId = this.tokenStorage.getUserId();
    if (userId) {
      this.clinicService.userClinics(userId, true).subscribe(clinics => {
        this.clinics = clinics;
        if (clinics.length > 0) {
          // Sélectionner la première clinique par défaut
          this.notificationForm.patchValue({ clinicId: clinics[0].id });
        }
      }, error => {
        console.error('Erreur lors de la récupération des cliniques:', error);
      });
    }
  }

  getResult(): ClinicNotificationResult {
    return {
      clinicId: this.notificationForm.value.clinicId,
      message: this.notificationForm.value.message,
      targets: this.notificationForm.value.targets ? 'vets' : undefined
    };
  }

  isDisabled(): boolean {
    return !this.notificationForm.valid;
  }

  get messageControl() {
    return this.notificationForm.get('message');
  }

  get messageErrorText(): string {
    const control = this.messageControl;
    if (control?.hasError('required')) {
      return 'Le message est obligatoire';
    }

    if (control?.hasError('minlength')) {
      return 'Le message doit contenir au moins 10 caractères';
    }

    if (control?.hasError('maxlength')) {
      return 'Le message ne peut pas dépasser 255 caractères';
    }

    return '';
  }
}
